$mpds_visavis_lib_plotly_view $mol_view
	sub /
		<= Plotly_root null
	data /
	layout *
	plot_options *
		displaylogo false
		displayModeBar false
		staticPlot true
